import { useCallback } from 'react';
import styled from 'styled-components';
import { Text } from '@adobe/react-spectrum';
import { Button } from 'components/basic/button';
import { Loading } from 'components/basic/loading';
import { Overlay } from 'components/basic/overlay';
import { Retry } from './retry';
import { Code } from 'api/codeApi';

// min-height はRSI共通設ヘッダー分を引いている
const StartServiceLayout = styled.div`
  text-align: center;
  min-height: calc(100vh - 62px);
`;

const TextLayout = styled.div`
  display: grid;
  justify-content: center;
  padding-top: 20px;
  text-align: left;
`;

interface StartServiceProps {
  handleGetCode: (redirectUri: string) => Promise<Code | undefined>;
  codeLoading: boolean;
  codeError: any;
  redirectUri: string;
}

export const StartService = (props: StartServiceProps) => {
  const { handleGetCode, codeLoading, codeError, redirectUri } = props;

  // RSIログインボタン押下処理
  const handleRefreshToken = useCallback(async () => {
    // コード取得を実施
    await handleGetCode(redirectUri).catch(() => null);
  }, [handleGetCode, redirectUri]);

  if (codeError) {
    return <Retry loading={codeLoading} retryMethod={handleRefreshToken} />;
  } else {
    return (
      <StartServiceLayout>
        <TextLayout>
          <Text>
            本サービスがお客様のテナントで使用するアプリケーション利用のための
          </Text>
          <Text>認証情報を発行し取得することを許可しますか？</Text>
        </TextLayout>
        <Button
          disabled={codeLoading}
          variant={'cta'}
          onClick={handleRefreshToken}
        >
          許可する
        </Button>
        {codeLoading && (
          <Overlay>
            <Loading />
          </Overlay>
        )}
      </StartServiceLayout>
    );
  }
};
